export const FRAME_OFFSET_CHANGED = 'FRAME_OFFSET_CHANGED';
export const PARTNER_HOST_URL = 'PARTNER_HOST_URL';
export const CALCULATED_DESIRED_MODAL_POSITION = 'CALCULATED_DESIRED_MODAL_POSITION';
export const RESPONSE_SCROLL_HAPPENED_NOTIFY_FOR = 'RESPONSE_SCROLL_HAPPENED_NOTIFY_FOR';

export function frameOffsetChanged(offset) {
    return JSON.stringify({ type: FRAME_OFFSET_CHANGED, offset });
}

export function partnerHostUrl(frameMessagePasscode) {
    return JSON.stringify({ type: PARTNER_HOST_URL, url: window.location.href, frameMessagePasscode });
}

export function sendCalculatedDesiredModalPositon(calculatedModalRect) {
    return JSON.stringify({ type: CALCULATED_DESIRED_MODAL_POSITION, calculatedModalRect });
}

export function sendScrollHappenedNotifyFor(notifyIdentifier, calculatedModalRect) {
    return JSON.stringify({ type: RESPONSE_SCROLL_HAPPENED_NOTIFY_FOR, notifyIdentifier, calculatedModalRect });
}
